import { userSlice } from "../slice/user";
import { codeSlice } from "../slice/code";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

export const rootReducer = combineReducers({
  userInfo: userSlice.reducer,
  code: codeSlice.reducer,
});

const persistConfig: any = {
  key: "root",
  storage: storageSession, // 사용할 스토리지를 정의해요.
  whitelist: ["userInfo","code"], // 유지 할 데이터를 정의해요 data
  // blacklist // 제외 할 데이터를 정의해요
};

const persistedReduer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReduer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
